import { MatCardModule } from '@angular/material/card';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { GlobalHeaderModule } from '@vi/global-header';
import { environment } from '../../../environments/environment';
import { LanguageDropdownComponent } from './language-dropdown/language-dropdown.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { FlexModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FeedbackModule } from '../shared/feedback/feedback.module';
import { MessagesModule } from '../shared/messages/messages.module';
import { MaintenanceMessageComponent } from './maintenance-message/maintenance-message.component';
import { ConfirmationModule } from '../shared/confirmation/confirmation.module';

@NgModule({
    declarations: [FooterComponent, HeaderComponent, LanguageDropdownComponent, MaintenanceMessageComponent],
    exports: [FooterComponent, HeaderComponent, MaintenanceMessageComponent],
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        MatCardModule,
        GlobalHeaderModule.forRoot({
            appId: environment.auth.appId,
            baseUrl: environment.auth.baseUrl,
            accountAppUrl: environment.auth.registerBaseUrl,
        }),
        RouterModule,
        FlexModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        FeedbackModule,
        MessagesModule,
        ConfirmationModule,
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class CoreModule {}
